import * as React from "react";

import { Badge } from "@repo/ui/components/badge";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@repo/ui/components/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@repo/ui/components/table";
import { createFileRoute } from "@tanstack/react-router";

import { buildIpadFilename } from "@/lib/filename-utils";

export const Route = createFileRoute("/_authed/filenames/players")({
  head: () => ({ meta: [{ title: "Players" }] }),
  component: RouteComponent,
});

function RouteComponent() {
  const players = React.useMemo(
    () => [
      {
        player: "Boaster",
        team: "Fnatic",
        teamCode: "FNC",
        role: "IGL",
        jersey: "07",
        status: "shot",
      },
      {
        player: "Derke",
        team: "Fnatic",
        teamCode: "FNC",
        role: "Duelist",
        jersey: "11",
        status: "shot",
      },
      {
        player: "TenZ",
        team: "Sentinels",
        teamCode: "SEN",
        role: "Flex",
        jersey: "05",
        status: "editing",
      },
      {
        player: "Zekken",
        team: "Sentinels",
        teamCode: "SEN",
        role: "Entry",
        jersey: "08",
        status: "shot",
      },
      { player: "Faker", team: "T1", teamCode: "T1", role: "Mid", jersey: "01", status: "queued" },
      {
        player: "Chovy",
        team: "Gen.G",
        teamCode: "GENG",
        role: "Mid",
        jersey: "03",
        status: "editing",
      },
    ],
    [],
  );

  return (
    <Card>
      <CardHeader>
        <CardTitle>Player naming preview</CardTitle>
        <CardDescription>
          Preview the safest export pattern for player deliverables.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Player</TableHead>
              <TableHead>Team</TableHead>
              <TableHead>Role</TableHead>
              <TableHead>Jersey</TableHead>
              <TableHead>iPad filename</TableHead>
              <TableHead>Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {players.map((row) => (
              <TableRow key={row.player}>
                <TableCell className="font-medium">{row.player}</TableCell>
                <TableCell>{row.team}</TableCell>
                <TableCell>{row.role}</TableCell>
                <TableCell>{row.jersey}</TableCell>
                <TableCell className="font-mono text-xs">
                  {buildIpadFilename([row.teamCode, row.player, row.jersey])}
                </TableCell>
                <TableCell>
                  <Badge variant={row.status === "shot" ? "secondary" : "outline"}>
                    {row.status}
                  </Badge>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
